import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import QuoteResult from '../../Components/QuoteResult.jsx'
import QuoteResultLaraLink from '../../Components/QuoteResultLaraLink.jsx'
import QuoteResultLabel from '../../Components/QuoteResultLabel.jsx'
import {quoteKinds} from '../../Services/api.jsx'
import Spinner from "../../Components/Spinner.jsx";

function InstantQuoteResult({
                              // State
                              showQuotes,
                              isFormChanged,
                              quotesArePending,
                              translatorsCount,
                              isAiQuoteEnabled,
                              firstCardSolution,
                              secondCardSolution,
                              thirdCardSolution,
                              // Quotes
                              posteditingQuote,
                              translationQuote,
                              translationRevisionQuote,
                              transcreationQuote,
                              laraInstantQuote,
                              // Loading states
                              posteditingQuoteIsPending,
                              translationQuoteIsPending,
                              translationRevisionQuoteIsPending,
                              transcreationQuoteIsPending,
                              laraInstantQuoteIsPending,
                              // Other props
                              targetLanguages,
                              currency,
                              rates,
                              selectedTimeZone,
                              deliveryDate,
                              showDeliveryDateModal,
                              onSelectQuote,
                            }) {
  const shouldShowQuotes = showQuotes && !isFormChanged

  if (!shouldShowQuotes) {
    return null
  }

  return (
      <div
          id={'instant-quote-form__quotes'}
          className={'instant-quote-form__quotes'}
      >
        {quotesArePending ? (
            <div
                className={
                  'instant-quote-form__quotes-header instant-quote-form__quotes-header--pending'
                }
            >
              <Spinner />
              <h5>
                {translatorsCount
                    ? i18n.t(
                        'Pages.InstantQuote.loadingQuoteTranslatorsCountMessage',
                        {number: translatorsCount},
                    )
                    : i18n.t('Pages.InstantQuote.loadingQuoteStaticMessage')}
              </h5>
            </div>
        ) : (
            <div className={'instant-quote-form__quotes-header'}>
              <h5>{i18n.t('Pages.InstantQuote.chooseYourSolution')}</h5>
            </div>
        )}
        <div
            className={`${
                !isAiQuoteEnabled
                    ? 'instant-quote-form__quotes-results'
                    : 'instant-quote-form__quotes-results__noborder'
            }`}
        >
          {isAiQuoteEnabled && (
              <div className={'instant-quote-form__quotes-labels'}>
                <div className={'instant-quote-form__quotes-labels__item--first'}>
                  <QuoteResultLabel label="human-services" />
                </div>
                <div className={'instant-quote-form__quotes-labels__item--last'}>
                  {thirdCardSolution === 'link' ? (
                      <QuoteResultLabel label="lara-link" />
                  ) : (
                      <QuoteResultLabel label="instant" />
                  )}
                </div>
              </div>
          )}
          {/* First card - changes based on solutionType */}
          {firstCardSolution === 'creative' ? (
              <QuoteResult
                  quoteKind={quoteKinds.transcreation}
                  quote={transcreationQuote}
                  isLoading={transcreationQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isAiQuoteEnabled={isAiQuoteEnabled}
                  labelType={isAiQuoteEnabled ? 'human-services' : null}
              />
          ) : (
              <QuoteResult
                  quoteKind={quoteKinds.translationRevision}
                  quote={translationRevisionQuote}
                  isLoading={translationRevisionQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isAiQuoteEnabled={isAiQuoteEnabled}
                  labelType={isAiQuoteEnabled ? 'human-services' : null}
              />
          )}
          {/* Second card - changes based on solutionType */}
          {secondCardSolution === 'premium' ? (
              <QuoteResult
                  quoteKind={quoteKinds.translationRevision}
                  quote={translationRevisionQuote}
                  isLoading={translationRevisionQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isBestSeller
                  isAiQuoteEnabled={isAiQuoteEnabled}
                  labelType={isAiQuoteEnabled ? 'human-services' : null}
              />
          ) : (
              <QuoteResult
                  quoteKind={quoteKinds.translation}
                  quote={translationQuote}
                  isLoading={translationQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isBestSeller
                  isAiQuoteEnabled={isAiQuoteEnabled}
                  labelType={isAiQuoteEnabled ? 'human-services' : null}
              />
          )}
          {/* Third card - changes based on solutionType */}
          {thirdCardSolution === 'economy' && (
              <QuoteResult
                  quoteKind={quoteKinds.postediting}
                  quote={posteditingQuote}
                  isLoading={posteditingQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isAiQuoteEnabled={isAiQuoteEnabled}
              />
          )}
          {thirdCardSolution === 'professional' && (
              <QuoteResult
                  quoteKind={quoteKinds.translation}
                  quote={translationQuote}
                  isLoading={translationQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isAiQuoteEnabled={isAiQuoteEnabled}
              />
          )}
          {thirdCardSolution === 'instant' && (
              <QuoteResult
                  quoteKind={quoteKinds.lara}
                  quote={laraInstantQuote}
                  isLoading={laraInstantQuoteIsPending}
                  onSubmit={onSelectQuote}
                  currentCurrency={currency}
                  rates={rates}
                  timeZone={selectedTimeZone}
                  deliveryDate={deliveryDate}
                  openDeliveryDate={showDeliveryDateModal}
                  targetLanguagesCount={targetLanguages.length ?? 0}
                  isAiQuoteEnabled={isAiQuoteEnabled}
                  labelType={isAiQuoteEnabled ? 'instant' : null}
              />
          )}
          {thirdCardSolution === 'link' && (
              <QuoteResultLaraLink
                  currentCurrency={currency}
                  rates={rates}
                  isLoading={
                      transcreationQuoteIsPending || translationRevisionQuoteIsPending
                  }
                  quote={laraInstantQuote}
                  isAiQuoteEnabled={isAiQuoteEnabled}
                  labelType={isAiQuoteEnabled ? 'lara-link' : null}
              />
          )}
        </div>
      </div>
  )
}

InstantQuoteResult.propTypes = {
  showQuotes: PropTypes.bool.isRequired,
  isFormChanged: PropTypes.bool.isRequired,
  quotesArePending: PropTypes.bool.isRequired,
  translatorsCount: PropTypes.number,
  isAiQuoteEnabled: PropTypes.bool.isRequired,
  firstCardSolution: PropTypes.string.isRequired,
  secondCardSolution: PropTypes.string.isRequired,
  thirdCardSolution: PropTypes.string.isRequired,
  posteditingQuote: PropTypes.object,
  translationQuote: PropTypes.object,
  translationRevisionQuote: PropTypes.object,
  transcreationQuote: PropTypes.object,
  laraInstantQuote: PropTypes.object,
  posteditingQuoteIsPending: PropTypes.bool.isRequired,
  translationQuoteIsPending: PropTypes.bool.isRequired,
  translationRevisionQuoteIsPending: PropTypes.bool.isRequired,
  transcreationQuoteIsPending: PropTypes.bool.isRequired,
  laraInstantQuoteIsPending: PropTypes.bool.isRequired,
  targetLanguages: PropTypes.array.isRequired,
  currency: PropTypes.string.isRequired,
  rates: PropTypes.object.isRequired,
  selectedTimeZone: PropTypes.object.isRequired,
  deliveryDate: PropTypes.object.isRequired,
  showDeliveryDateModal: PropTypes.func.isRequired,
  onSelectQuote: PropTypes.func.isRequired,
}

export default InstantQuoteResult
